export default class AccountModel {
    constructor() {
        this.id = null;
        this.name = null;
        this.amount = 0;
        this.project_id = null;
        this.parent_id = null;
        this.user_id = null;
    }
}